import React from 'react'

function Map() {
    return (
             <div class="mapouter col-12"><div class="gmap_canvas"><iframe width="100%" height="500" id="gmap_canvas" src="https://maps.google.com/maps?q=2880%20Broadway,%20New%20York&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" title='myFrame'></iframe></div></div>
   
    )
}

export default Map
